import { Text } from '@vtex/admin-ui'
import { IncompatibleField } from 'hooks'
import { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { messages } from './messages'
import styles from './styles.css'

type Props = {
  incompatibleFields: IncompatibleField[]
  hasIncompatibilities: boolean
  fieldMessages: Record<
    string,
    { section: { id: string }; config?: { id: string } }
  >
}

type TableRow = {
  section: string
  config: string
}

export function IncompatibleTable(props: Props) {
  const { incompatibleFields, hasIncompatibilities, fieldMessages } = props
  const { $t } = useIntl()
  const [tableData, setTableData] = useState<TableRow[]>([])

  useEffect(() => {
    const dynamicTableData: TableRow[] = []
    if (hasIncompatibilities) {
      incompatibleFields.forEach((field) => {
        const messages =
          fieldMessages[field.field as keyof typeof fieldMessages]
        if (messages) {
          dynamicTableData.push({
            section: $t(messages.section),
            config: messages.config ? $t(messages.config) : '',
          })
        }
      })
    }

    setTableData(dynamicTableData)
  }, [$t, hasIncompatibilities, incompatibleFields, fieldMessages])

  return (
    <table className={styles.table}>
      <thead>
        <tr>
          <th className={styles.tableHeaderCell}>
            <Text variant="detail" tone="secondary">
              {$t(messages.header.section)}
            </Text>
          </th>
          <th className={styles.tableHeaderCell}>
            <Text variant="detail" tone="secondary">
              {$t(messages.header.config)}
            </Text>
          </th>
        </tr>
      </thead>
      <tbody>
        {tableData.map((row, index) => (
          <tr key={index}>
            <td className={styles.tableBodyCell}>
              <Text variant="action1">{row.section}</Text>
            </td>
            <td className={styles.tableBodyCell}>
              <Text variant="body">{row.config}</Text>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}
